import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
  selector: 'button[appButton]',
  standalone: false
})
export class ButtonDirective implements OnInit {
  private elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.elementRef.nativeElement.style.fontFamily = 'Kanit, Pridi, serif';
  }
}
